/**
 * Custom Sticky Cart – replaces GoKwik sticky cart.
 * Same behaviour: show when cart has items, click opens cart drawer (Kwikcart if available, otherwise Shopify native cart) + fireViewCart.
 */
(function () {
  "use strict";

  const fetchCart = () => fetch("/cart.js").then((r) => r.json());

  const excludedPaths = [
    "/pages/orders",
    "/pages/skin-assessment",
    "/pages/skin-assessment-ebo",
    "/pages/skin-assessment-demo",
    "/pages/refer",
    "/pages/wallet",
    "/pages/my-assessments",
    "/pages/educate",
  ];
  const isCustomersPage = () =>
    Array.from(document.body.classList || []).some((c) =>
      c.startsWith("hdt-page-type-customers"),
    );
  const isExcludedPage = () => {
    const path = typeof location !== "undefined" ? location.pathname : "";
    if (isCustomersPage()) return true;
    return excludedPaths.some((p) => path.indexOf(p) === 0);
  };

  const container = () => document.getElementById("custom-sticky-cart");
  const imagesEl = () =>
    document.querySelector("[data-custom-sticky-cart-images]");
  const countEl = () =>
    document.querySelector("[data-custom-sticky-cart-count]");
  const trigger = () =>
    document.querySelector("[data-custom-sticky-cart-trigger]");

  let lastItemCount = -1;

  function rebuildImages(imgWrap, items, didAdd, isFirstItem) {
    imgWrap.innerHTML = "";
    items.forEach(function (item, index) {
      if (!item.image) return;
      var imgWrapEl = document.createElement("span");
      imgWrapEl.className = "custom-sticky-cart__img-wrap";
      var img = document.createElement("img");
      img.src = item.image;
      img.alt = item.title || "";
      img.setAttribute("loading", "lazy");
      // Only add drop-in animation if adding to existing cart (not first item)
      if (didAdd && index === 0 && !isFirstItem) {
        imgWrapEl.classList.add("custom-sticky-cart__img-wrap--drop-in");
      }
      imgWrapEl.appendChild(img);
      imgWrap.appendChild(imgWrapEl);
    });
  }

  function render(cart) {
    const wrap = container();
    const imgWrap = imagesEl();
    const cnt = countEl();
    if (!wrap || !imgWrap || !cnt) return;

    if (isExcludedPage()) {
      wrap.style.setProperty("display", "none", "important");
      wrap.setAttribute("aria-hidden", "true");
      wrap.classList.remove("custom-sticky-cart--animate-in");
      lastItemCount = 0;
      return;
    }

    if (!cart || !cart.items || !cart.items.length) {
      var isVisible =
        wrap.style.display !== "none" &&
        wrap.getAttribute("aria-hidden") !== "true";
      if (isVisible) {
        // Animate out before hiding
        wrap.classList.remove("custom-sticky-cart--animate-in");
        wrap.classList.add("custom-sticky-cart--animate-out");
        wrap.addEventListener("animationend", function onEnd() {
          wrap.removeEventListener("animationend", onEnd);
          wrap.style.setProperty("display", "none", "important");
          wrap.setAttribute("aria-hidden", "true");
          wrap.classList.remove(
            "custom-sticky-cart--animate-out",
            "custom-sticky-cart--expanded",
            "custom-sticky-cart--compact",
            "custom-sticky-cart--reveal",
          );
        });
      } else {
        wrap.style.setProperty("display", "none", "important");
        wrap.setAttribute("aria-hidden", "true");
      }
      lastItemCount = 0;
      return;
    }

    const items = cart.items.slice(0, 2);
    const plural = cart.item_count === 1 ? "" : "s";
    const didAdd = lastItemCount >= 0 && cart.item_count > lastItemCount;
    const didRemove =
      lastItemCount > 0 &&
      cart.item_count < lastItemCount &&
      cart.item_count > 0;
    const wasEmpty = lastItemCount === 0 || lastItemCount < 0;
    const isFirstItem = didAdd && wasEmpty;

    // If item removed and cart still has items, play pop-out + GIF then update
    if (didRemove) {
      var firstImgWrap = imgWrap.querySelector(
        ".custom-sticky-cart__img-wrap:first-child",
      );
      if (firstImgWrap) {
        // Get the position of the image before it flies out
        var rect = firstImgWrap.getBoundingClientRect();
        var imgCenterX = rect.left + rect.width / 2;
        // The pop-out animation ends 80px above the image center
        var disappearY = rect.top - 80;

        firstImgWrap.classList.add("custom-sticky-cart__img-wrap--pop-out");

        // When pop-out finishes, show GIF at the vanish point (in the air)
        setTimeout(function () {
          var gifOverlay = document.createElement("span");
          gifOverlay.className = "custom-sticky-cart__gif-overlay";
          gifOverlay.style.left = imgCenterX - 30 + "px";
          gifOverlay.style.top = disappearY - 30 + "px";
          var gifImg = document.createElement("img");
          gifImg.src =
            "https://cdn.shopify.com/s/files/1/0888/8057/8807/files/50x50.gif?v=1770967574";
          gifImg.alt = "";
          gifOverlay.appendChild(gifImg);
          document.body.appendChild(gifOverlay);

          // Remove GIF after it plays
          setTimeout(function () {
            if (gifOverlay.parentNode)
              gifOverlay.parentNode.removeChild(gifOverlay);
          }, 700);
        }, 350);

        // After animations, update images normally
        setTimeout(function () {
          rebuildImages(imgWrap, items, false, false);
          lastItemCount = cart.item_count;
          cnt.textContent = cart.item_count + " Item" + plural;
        }, 1000);
        return;
      }
    }

    rebuildImages(imgWrap, items, didAdd, isFirstItem);

    lastItemCount = cart.item_count;

    cnt.textContent = `${cart.item_count} Item${plural}`;
    const wasHidden =
      wrap.style.display === "none" ||
      wrap.getAttribute("aria-hidden") === "true";

    if (wasHidden) {
      wrap.classList.remove(
        "custom-sticky-cart--animate-in",
        "custom-sticky-cart--expanded",
        "custom-sticky-cart--compact",
        "custom-sticky-cart--reveal",
      );
      if (isFirstItem) {
        // First item to empty cart: compact → expand
        wrap.classList.add("custom-sticky-cart--compact");
        wrap.offsetHeight;
      } else {
        // Cart already had items or page load: show expanded + reveal immediately
        wrap.classList.add(
          "custom-sticky-cart--expanded",
          "custom-sticky-cart--reveal",
        );
      }
      wrap.style.removeProperty("display");
      wrap.setAttribute("aria-hidden", "false");
      wrap.offsetHeight;
      wrap.classList.add("custom-sticky-cart--animate-in");
      if (isFirstItem) {
        setTimeout(function () {
          wrap.classList.remove("custom-sticky-cart--compact");
          wrap.classList.add("custom-sticky-cart--expanded");
          // Reveal text after pill finishes expanding
          setTimeout(function () {
            wrap.classList.add("custom-sticky-cart--reveal");
          }, 350);
        }, 500);
      }
    } else if (isFirstItem) {
      wrap.classList.remove(
        "custom-sticky-cart--expanded",
        "custom-sticky-cart--reveal",
      );
      wrap.classList.add("custom-sticky-cart--compact");
      wrap.offsetHeight;
      setTimeout(function () {
        wrap.classList.remove("custom-sticky-cart--compact");
        wrap.classList.add("custom-sticky-cart--expanded");
        // Reveal text after pill finishes expanding
        setTimeout(function () {
          wrap.classList.add("custom-sticky-cart--reveal");
        }, 350);
      }, 500);
    } else {
      // Cart already visible: keep expanded + revealed
      wrap.classList.remove("custom-sticky-cart--compact");
      wrap.classList.add(
        "custom-sticky-cart--expanded",
        "custom-sticky-cart--reveal",
      );
    }
  }

  function update(cart) {
    render(cart);
  }

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    // Fire view_cart once here. Opening GoKwik side cart also posts
    // view_cart_clicked, which would otherwise emit a second view_cart.
    // Flag lets the message handler skip that duplicate.
    window.__viewCartTrackedBySticky = true;
    if (window.__viewCartStickyTimeout) {
      clearTimeout(window.__viewCartStickyTimeout);
    }
    window.__viewCartStickyTimeout = setTimeout(function () {
      window.__viewCartTrackedBySticky = false;
      window.__viewCartStickyTimeout = null;
    }, 2000);

    if (typeof window.fireViewCart === "function") {
      window.fireViewCart("sticky_cart");
    }

    // Try to open Kwikcart side cart first (if available)
    if (typeof window.openGokwikSideCart === "function") {
      window.openGokwikSideCart();
      return;
    }

    // Fallback to Shopify's native cart drawer
    const cartDrawer = document.querySelector("hdt-cart-drawer");
    if (cartDrawer && typeof cartDrawer.openDialog === "function") {
      // Use the openDialog method if available
      cartDrawer.openDialog();
    } else if (cartDrawer) {
      // Fallback: set the 'open' attribute
      cartDrawer.setAttribute("open", "");
    } else {
      // If drawer doesn't exist, try clicking the cart icon
      const cartIcon = document.querySelector('[aria-controls="CartDrawer"]');
      if (cartIcon) {
        cartIcon.click();
      } else {
        // Last resort: navigate to cart page
        window.location.href = "/cart";
      }
    }
  }

  function bind() {
    const btn = trigger();
    if (btn) {
      btn.removeEventListener("click", handleClick);
      btn.addEventListener("click", handleClick);
    }
  }

  // Debounce function to prevent excessive updates
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Debounced update function to prevent performance issues when adding multiple products
  const debouncedUpdate = debounce((cart) => {
    if (cart) {
      update(cart);
    } else {
      fetchCart().then(update);
    }
  }, 300); // 300ms debounce - batches rapid cart changes

  function init() {
    bind();
    fetchCart().then(update);

    document.addEventListener("cart:change", (ev) => {
      const cart = ev.detail && ev.detail.cart;
      // Use debounced update to prevent performance degradation when adding multiple products
      debouncedUpdate(cart);
    });

    document.addEventListener("cart:refresh", () => {
      fetchCart().then(update);
    });

    window.addEventListener("message", (e) => {
      const name = (e.data && e.data.name) || "";
      if (name === "quantity_change" || name === "close_sc") {
        fetchCart().then(update);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
